import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import {inject, observer} from 'mobx-react';

import Container from 'components/Layout/Container';
import ViewTitle from 'components/Layout/ViewTitle';
import {FormattedMessage} from 'components/FormattedComponents';

import messages from './messages';
import {
  Section,
  SectionTitle,
  SectionSubtitle,
  SectionDelimiter,
  TextWrapper,
  ViewWrapper,
  StyledLink,
  StyledButton,
  ButtonWrapper
} from './styles';

import {PRIVACY_POLICY_URL} from '../../constants';

@inject('store')
@observer
class PrivacyCentreView extends Component {
  render() {
    const {
      intl: {formatMessage},
      store: {
        cookiePreference: {openCookiePreferencesDialog}
      },
      isMobile
    } = this.props;

    return (
      <Container>
        <ViewWrapper isMobile={isMobile}>
          {!isMobile && <ViewTitle title={formatMessage(messages.privacy)} />}

          <Section isMobile={isMobile}>
            <TextWrapper isMobile={isMobile}>
              <SectionTitle>{formatMessage(messages.privacyPolicy)}</SectionTitle>
              <SectionSubtitle>{formatMessage(messages.readMoreDataCollection)}</SectionSubtitle>
            </TextWrapper>
            <ButtonWrapper isMobile={isMobile}>
              <StyledButton href={PRIVACY_POLICY_URL} target="_blank">
                {formatMessage(messages.view).toUpperCase()}
              </StyledButton>
            </ButtonWrapper>
          </Section>

          <SectionDelimiter />

          <Section isMobile={isMobile}>
            <TextWrapper isMobile={isMobile}>
              <SectionTitle>{formatMessage(messages.cookiePreferences)}</SectionTitle>
              <SectionSubtitle>
                <FormattedMessage
                  {...messages.manageYourCookiePreferences}
                  values={{
                    cookieStatementLink: (
                      <StyledLink href={PRIVACY_POLICY_URL} target="_blank">
                        <FormattedMessage {...messages.cookieStatement} />
                      </StyledLink>
                    )
                  }}
                />
              </SectionSubtitle>
            </TextWrapper>
            <ButtonWrapper isMobile={isMobile}>
              <StyledButton onClick={openCookiePreferencesDialog}>
                {formatMessage(messages.manage).toUpperCase()}
              </StyledButton>
            </ButtonWrapper>
          </Section>
        </ViewWrapper>
      </Container>
    );
  }
}

export default injectIntl(PrivacyCentreView);
